import React, { useState, useEffect } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const NumberInputComponent = ({ numberInput = {} }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = numberInput.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = numberInput;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = numberInput;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = numberInput;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = numberInput;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = numberInput;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        numberInput.backgroundImage &&
        numberInput.backgroundImage.startsWith("./")
      ) {
        const imageName = numberInput.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(numberInput.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [numberInput.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        numberInput.labelbackgroundImagelabel &&
        numberInput.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = numberInput.labelbackgroundImagelabel.replace(
          "./",
          ""
        );
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(numberInput.labelbackgroundImagelabel);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [numberInput.labelbackgroundImagelabel, files]);

  const focusedStyles =
    isDivFocused && numberInput.pseudoClass === "focus"
      ? {
          width: numberInput.focusedwidth || numberInput.width || "200px",
          height: numberInput.focusedheight || numberInput.height || "auto",

          padding: numberInput.focusedpadding || numberInput.padding || "0",
          paddingTop:
            numberInput.focusedpaddingTop || numberInput.focusedpadding || "0",
          paddingRight:
            numberInput.focusedpaddingRight ||
            numberInput.focusedpadding ||
            "0",
          paddingBottom:
            numberInput.focusedpaddingBottom ||
            numberInput.focusedpadding ||
            "0",
          paddingLeft:
            numberInput.focusedpaddingLeft || numberInput.focusedpadding || "0",
          margin: numberInput.focusedmargin || numberInput.margin || "0px",
          marginTop:
            numberInput.focusedmarginTop || numberInput.focusedmargin || "0px",
          marginRight:
            numberInput.focusedmarginRight ||
            numberInput.focusedmargin ||
            "0px",
          marginBottom:
            numberInput.focusedmarginBottom ||
            numberInput.focusedmargin ||
            "0px",
          marginLeft:
            numberInput.focusedmarginLeft ||
            numberInput.focusedmargin ||
            "10px",

          borderTop:
            numberInput.focusedborderTop ||
            numberInput.focusedborder ||
            numberInput.border ||
            "1px solid #000000",
          borderRight:
            numberInput.focusedborderRight ||
            numberInput.focusedborder ||
            numberInput.border ||
            "1px solid #000000",
          borderBottom:
            numberInput.focusedborderBottom ||
            numberInput.focusedborder ||
            numberInput.border ||
            "1px solid #000000",
          borderLeft:
            numberInput.focusedborderLeft ||
            numberInput.focusedborder ||
            numberInput.border ||
            "1px solid #000000",
          borderSapcing:
            numberInput.focusedborderSpacing ||
            numberInput.borderSpacing ||
            "0px",
          borderCollapse:
            numberInput.focusedborderCollapse ||
            numberInput.borderCollapse ||
            "0px",
          borderRadius:
            numberInput.focusedborderRadius || numberInput.borderRadius || "0",
          outline: numberInput.focusedoutline || numberInput.outline || "none",

          position:
            numberInput.focusedposition || numberInput.position || "relative",
          top: numberInput.focusedtop || numberInput.top || "auto",
          right: numberInput.focusedright || numberInput.right || "auto",
          bottom: numberInput.focusedbottom || numberInput.bottom || "auto",
          left: numberInput.focusedleft || numberInput.left || "auto",
          zIndex: numberInput.focusedzIndex || numberInput.zIndex || "auto",

          color: numberInput.focusedcolor || numberInput.color || "#000000",
          backgroundColor:
            numberInput.focusedbackgroundColor ||
            numberInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (numberInput.focusedbackgroundImage) {
              if (numberInput.focusedbackgroundImage.startsWith("./")) {
                const imageName = numberInput.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${numberInput.focusedbackgroundImage})`;
            }
            if (numberInput.backgroundImage) {
              if (numberInput.backgroundImage.startsWith("./")) {
                const imageName = numberInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${numberInput.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            numberInput.focusedbackgroundPosition ||
            numberInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            numberInput.focusedbackgroundSize ||
            numberInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            numberInput.focusedbackgroundRepeat ||
            numberInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            numberInput.focusedbackgroundAttachment ||
            numberInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            numberInput.focusedboxShadow || numberInput.boxShadow || "none",
          opacity: numberInput.focusedOpacity || numberInput.opacity || 1,
          display:
            numberInput.focuseddisplay || numberInput.display || "inline",

          fontFamily:
            numberInput.focusedfontFamily ||
            numberInput.fontFamily ||
            "inherit",
          fontSize:
            numberInput.focusedfontSize || numberInput.fontSize || "inherit",
          fontWeight:
            numberInput.focusedfontWeight || numberInput.fontWeight || "normal",
          fontStyle:
            numberInput.focusedfontStyle || numberInput.fontStyle || "normal",
          fontVariant:
            numberInput.focusedfontVariant ||
            numberInput.fontVariant ||
            "normal",
          lineHeight:
            numberInput.focusedlineHeight || numberInput.lineHeight || "normal",
          textShadow:
            numberInput.focusedtextShadow || numberInput.textShadow || "none",
          textAlign:
            numberInput.focusedtextAlign || numberInput.textAlign || "left",
          verticalAlign:
            numberInput.focusedverticalAlign ||
            numberInput.verticalAlign ||
            "baseline",
          textDecoration:
            numberInput.focusedtextDecoration ||
            numberInput.textDecoration ||
            "none",
          textTransform:
            numberInput.focusedtextTransform ||
            numberInput.textTransform ||
            "none",
          letterSpacing:
            numberInput.focusedletterSpacing ||
            numberInput.letterSpacing ||
            "normal",
          wordSpacing:
            numberInput.focusedwordSpacing ||
            numberInput.wordSpacing ||
            "normal",
          textIndent:
            numberInput.focusedtextIndent || numberInput.textIndent || "0",
          whiteSpace:
            numberInput.focusedwhiteSpace || numberInput.whiteSpace || "normal",
          textOverflow:
            numberInput.focusedtextOverflow ||
            numberInput.textOverflow ||
            "clip",
          direction:
            numberInput.focuseddirection || numberInput.direction || "ltr",
          unicodeBidi:
            numberInput.focusedunicodeBidi ||
            numberInput.unicodeBidi ||
            "normal",
          writingMode:
            numberInput.focusedwritingMode ||
            numberInput.writingMode ||
            "horizontal-tb",

          cursor: numberInput.focusedcursor || numberInput.cursor || "default",
          transform:
            numberInput.focusedtransform || numberInput.transform || "none",
          transition:
            numberInput.focusedtransition || numberInput.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && numberInput.pseudoClass === "hover"
      ? {
          width: numberInput.hoveredwidth || numberInput.width || "200px",
          height: numberInput.hoveredheight || numberInput.height || "auto",

          padding: numberInput.hoveredpadding || numberInput.padding || "0",
          paddingTop:
            numberInput.hoveredpaddingTop || numberInput.hoveredpadding || "0",
          paddingRight:
            numberInput.hoveredpaddingRight ||
            numberInput.hoveredpadding ||
            "0",
          paddingBottom:
            numberInput.hoveredpaddingBottom ||
            numberInput.hoveredpadding ||
            "0",
          paddingLeft:
            numberInput.hoveredpaddingLeft || numberInput.hoveredpadding || "0",
          margin: numberInput.hoveredmargin || numberInput.margin || "0px",
          marginTop:
            numberInput.hoveredmarginTop || numberInput.hoveredmargin || "0px",
          marginRight:
            numberInput.hoveredmarginRight ||
            numberInput.hoveredmargin ||
            "0px",
          marginBottom:
            numberInput.hoveredmarginBottom ||
            numberInput.hoveredmargin ||
            "0px",
          marginLeft:
            numberInput.hoveredmarginLeft ||
            numberInput.hoveredmargin ||
            "10px",

          borderTop:
            numberInput.hoveredborderTop ||
            numberInput.hoveredborder ||
            numberInput.border ||
            "1px solid #000000",
          borderRight:
            numberInput.hoveredborderRight ||
            numberInput.hoveredborder ||
            numberInput.border ||
            "1px solid #000000",
          borderBottom:
            numberInput.hoveredborderBottom ||
            numberInput.hoveredborder ||
            numberInput.border ||
            "1px solid #000000",
          borderLeft:
            numberInput.hoveredborderLeft ||
            numberInput.hoveredborder ||
            numberInput.border ||
            "1px solid #000000",
          borderSapcing:
            numberInput.hoveredborderSpacing ||
            numberInput.borderSpacing ||
            "0px",
          borderCollapse:
            numberInput.hoveredborderCollapse ||
            numberInput.borderCollapse ||
            "0px",
          borderRadius:
            numberInput.hoveredborderRadius || numberInput.borderRadius || "0",
          outline: numberInput.hoveredoutline || numberInput.outline || "none",

          position:
            numberInput.hoveredposition || numberInput.position || "relative",
          top: numberInput.hoveredtop || numberInput.top || "auto",
          right: numberInput.hoveredright || numberInput.right || "auto",
          bottom: numberInput.hoveredbottom || numberInput.bottom || "auto",
          left: numberInput.hoveredleft || numberInput.left || "auto",
          zIndex: numberInput.hoveredzIndex || numberInput.zIndex || "auto",

          color: numberInput.hoveredcolor || numberInput.color || "#000000",
          backgroundColor:
            numberInput.hoveredbackgroundColor ||
            numberInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (numberInput.hoveredbackgroundImage) {
              if (numberInput.hoveredbackgroundImage.startsWith("./")) {
                const imageName = numberInput.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${numberInput.hoveredbackgroundImage})`;
            }
            if (numberInput.backgroundImage) {
              if (numberInput.backgroundImage.startsWith("./")) {
                const imageName = numberInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${numberInput.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            numberInput.hoveredbackgroundPosition ||
            numberInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            numberInput.hoveredbackgroundSize ||
            numberInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            numberInput.hoveredbackgroundRepeat ||
            numberInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            numberInput.hoveredbackgroundAttachment ||
            numberInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            numberInput.hoveredboxShadow || numberInput.boxShadow || "none",
          opacity: numberInput.hoveredOpacity || numberInput.opacity || 1,
          display:
            numberInput.hovereddisplay || numberInput.display || "inline",

          fontFamily:
            numberInput.hoveredfontFamily ||
            numberInput.fontFamily ||
            "inherit",
          fontSize:
            numberInput.hoveredfontSize || numberInput.fontSize || "inherit",
          fontWeight:
            numberInput.hoveredfontWeight || numberInput.fontWeight || "normal",
          fontStyle:
            numberInput.hoveredfontStyle || numberInput.fontStyle || "normal",
          fontVariant:
            numberInput.hoveredfontVariant ||
            numberInput.fontVariant ||
            "normal",
          lineHeight:
            numberInput.hoveredlineHeight || numberInput.lineHeight || "normal",
          textShadow:
            numberInput.hoveredtextShadow || numberInput.textShadow || "none",
          textAlign:
            numberInput.hoveredtextAlign || numberInput.textAlign || "left",
          verticalAlign:
            numberInput.hoveredverticalAlign ||
            numberInput.verticalAlign ||
            "baseline",
          textDecoration:
            numberInput.hoveredtextDecoration ||
            numberInput.textDecoration ||
            "none",
          textTransform:
            numberInput.hoveredtextTransform ||
            numberInput.textTransform ||
            "none",
          letterSpacing:
            numberInput.hoveredletterSpacing ||
            numberInput.letterSpacing ||
            "normal",
          wordSpacing:
            numberInput.hoveredwordSpacing ||
            numberInput.wordSpacing ||
            "normal",
          textIndent:
            numberInput.hoveredtextIndent || numberInput.textIndent || "0",
          whiteSpace:
            numberInput.hoveredwhiteSpace || numberInput.whiteSpace || "normal",
          textOverflow:
            numberInput.hoveredtextOverflow ||
            numberInput.textOverflow ||
            "clip",
          direction:
            numberInput.hovereddirection || numberInput.direction || "ltr",
          unicodeBidi:
            numberInput.hoveredunicodeBidi ||
            numberInput.unicodeBidi ||
            "normal",
          writingMode:
            numberInput.hoveredwritingMode ||
            numberInput.writingMode ||
            "horizontal-tb",

          cursor: numberInput.hoveredcursor || numberInput.cursor || "default",
          transform:
            numberInput.hoveredtransform || numberInput.transform || "none",
          transition:
            numberInput.hoveredtransition || numberInput.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && numberInput.pseudoClass === "active"
      ? {
          width: numberInput.activatedwidth || numberInput.width || "200px",
          height: numberInput.activatedheight || numberInput.height || "auto",

          padding: numberInput.activatedpadding || numberInput.padding || "0",
          paddingTop:
            numberInput.activatedpaddingTop ||
            numberInput.activatedpadding ||
            "0",
          paddingRight:
            numberInput.activatedpaddingRight ||
            numberInput.activatedpadding ||
            "0",
          paddingBottom:
            numberInput.activatedpaddingBottom ||
            numberInput.activatedpadding ||
            "0",
          paddingLeft:
            numberInput.activatedpaddingLeft ||
            numberInput.activatedpadding ||
            "0",
          margin: numberInput.activatedmargin || numberInput.margin || "0px",
          marginTop:
            numberInput.activatedmarginTop ||
            numberInput.activatedmargin ||
            "0px",
          marginRight:
            numberInput.activatedmarginRight ||
            numberInput.activatedmargin ||
            "0px",
          marginBottom:
            numberInput.activatedmarginBottom ||
            numberInput.activatedmargin ||
            "0px",
          marginLeft:
            numberInput.activatedmarginLeft ||
            numberInput.activatedmargin ||
            "10px",

          borderTop:
            numberInput.activatedborderTop ||
            numberInput.activatedborder ||
            numberInput.border ||
            "1px solid #000000",
          borderRight:
            numberInput.activatedborderRight ||
            numberInput.activatedborder ||
            numberInput.border ||
            "1px solid #000000",
          borderBottom:
            numberInput.activatedborderBottom ||
            numberInput.activatedborder ||
            numberInput.border ||
            "1px solid #000000",
          borderLeft:
            numberInput.activatedborderLeft ||
            numberInput.activatedborder ||
            numberInput.border ||
            "1px solid #000000",
          borderSapcing:
            numberInput.activatedborderSpacing ||
            numberInput.borderSpacing ||
            "0px",
          borderCollapse:
            numberInput.activatedborderCollapse ||
            numberInput.borderCollapse ||
            "0px",
          borderRadius:
            numberInput.activatedborderRadius ||
            numberInput.borderRadius ||
            "0",
          outline:
            numberInput.activatedoutline || numberInput.outline || "none",

          position:
            numberInput.activatedposition || numberInput.position || "relative",
          top: numberInput.activatedtop || numberInput.top || "auto",
          right: numberInput.activatedright || numberInput.right || "auto",
          bottom: numberInput.activatedbottom || numberInput.bottom || "auto",
          left: numberInput.activatedleft || numberInput.left || "auto",
          zIndex: numberInput.activatedzIndex || numberInput.zIndex || "auto",

          color: numberInput.activatedcolor || numberInput.color || "#000000",
          backgroundColor:
            numberInput.activatedbackgroundColor ||
            numberInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (numberInput.activatedbackgroundImage) {
              if (numberInput.activatedbackgroundImage.startsWith("./")) {
                const imageName = numberInput.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${numberInput.activatedbackgroundImage})`;
            }
            if (numberInput.backgroundImage) {
              if (numberInput.backgroundImage.startsWith("./")) {
                const imageName = numberInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${numberInput.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            numberInput.activatedbackgroundPosition ||
            numberInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            numberInput.activatedbackgroundSize ||
            numberInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            numberInput.activatedbackgroundRepeat ||
            numberInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            numberInput.activatedbackgroundAttachment ||
            numberInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            numberInput.activatedboxShadow || numberInput.boxShadow || "none",
          opacity: numberInput.activatedOpacity || numberInput.opacity || 1,
          display:
            numberInput.activateddisplay || numberInput.display || "inline",

          fontFamily:
            numberInput.activatedfontFamily ||
            numberInput.fontFamily ||
            "inherit",
          fontSize:
            numberInput.activatedfontSize || numberInput.fontSize || "inherit",
          fontWeight:
            numberInput.activatedfontWeight ||
            numberInput.fontWeight ||
            "normal",
          fontStyle:
            numberInput.activatedfontStyle || numberInput.fontStyle || "normal",
          fontVariant:
            numberInput.activatedfontVariant ||
            numberInput.fontVariant ||
            "normal",
          lineHeight:
            numberInput.activatedlineHeight ||
            numberInput.lineHeight ||
            "normal",
          textShadow:
            numberInput.activatedtextShadow || numberInput.textShadow || "none",
          textAlign:
            numberInput.activatedtextAlign || numberInput.textAlign || "left",
          verticalAlign:
            numberInput.activatedverticalAlign ||
            numberInput.verticalAlign ||
            "baseline",
          textDecoration:
            numberInput.activatedtextDecoration ||
            numberInput.textDecoration ||
            "none",
          textTransform:
            numberInput.activatedtextTransform ||
            numberInput.textTransform ||
            "none",
          letterSpacing:
            numberInput.activatedletterSpacing ||
            numberInput.letterSpacing ||
            "normal",
          wordSpacing:
            numberInput.activatedwordSpacing ||
            numberInput.wordSpacing ||
            "normal",
          textIndent:
            numberInput.activatedtextIndent || numberInput.textIndent || "0",
          whiteSpace:
            numberInput.activatedwhiteSpace ||
            numberInput.whiteSpace ||
            "normal",
          textOverflow:
            numberInput.activatedtextOverflow ||
            numberInput.textOverflow ||
            "clip",
          direction:
            numberInput.activateddirection || numberInput.direction || "ltr",
          unicodeBidi:
            numberInput.activatedunicodeBidi ||
            numberInput.unicodeBidi ||
            "normal",
          writingMode:
            numberInput.activatedwritingMode ||
            numberInput.writingMode ||
            "horizontal-tb",

          cursor:
            numberInput.activatedcursor || numberInput.cursor || "default",
          transform:
            numberInput.activatedtransform || numberInput.transform || "none",
          transition:
            numberInput.activatedtransition || numberInput.transition || "none",
        }
      : {};

  const inputStyle = {
    width: numberInput.width || "200px",
    height: numberInput.height || "auto",

    margin: numberInput.margin || "0px",
    marginTop: numberInput.marginTop || numberInput.margin || "0",
    marginRight: numberInput.marginRight || numberInput.margin || "0px",
    marginBottom: numberInput.marginBottom || numberInput.margin || "0",
    marginLeft: numberInput.marginLeft || numberInput.margin || "10px",
    padding: numberInput.padding || "0px",
    paddingTop: numberInput.paddingTop || numberInput.padding || "0",
    paddingRight: numberInput.paddingRight || numberInput.padding || "0",
    paddingBottom: numberInput.paddingBottom || numberInput.padding || "0",
    paddingLeft: numberInput.paddingLeft || numberInput.padding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : numberInput.borderTop || numberInput.border || "1px solid #000000",
    borderRight: isHovered
      ? "1px dashed #555"
      : numberInput.borderRight || numberInput.border || "1px solid #000000",
    borderBottom: isHovered
      ? "1px dashed #555"
      : numberInput.borderBottom || numberInput.border || "1px solid #000000",
    borderLeft: isHovered
      ? "1px dashed #555"
      : numberInput.borderLeft || numberInput.border || "1px solid #000000",

    borderSapcing: numberInput.borderSpacing || "0px",
    borderCollapse: numberInput.borderCollapse || "0px",
    borderRadius: numberInput.borderRadius || "0",
    outline: numberInput.outline || "none",

    position: numberInput.position || "static",
    top: numberInput.top || "auto",
    right: numberInput.right || "auto",
    bottom: numberInput.bottom || "auto",
    left: numberInput.left || "auto",
    zIndex: numberInput.zIndex || "auto",

    color: numberInput.color || "#000000",
    backgroundColor: numberInput.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      numberInput.focusedbackgroundPosition ||
      numberInput.backgroundPosition ||
      "0% 0%",
    backgroundSize:
      numberInput.focusedbackgroundSize || numberInput.backgroundSize || "auto",
    backgroundRepeat:
      numberInput.focusedbackgroundRepeat ||
      numberInput.backgroundRepeat ||
      "repeat",
    backgroundAttachment:
      numberInput.focusedbackgroundAttachment ||
      numberInput.backgroundAttachment ||
      "scroll",

    fontSize: numberInput.fontSize || "inherit",
    fontFamily: numberInput.fontFamily || "inherit",
    fontWeight: numberInput.fontWeight || "normal",
    fontStyle: numberInput.fontStyle || "normal",
    fontVariant: numberInput.fontVariant || "normal",
    lineHeight: numberInput.lineHeight || "normal",
    textAlign: numberInput.textAlign || "left",
    textDecoration: numberInput.textDecoration || "none",
    textTransform: numberInput.textTransform || "none",
    textShadow: numberInput.textShadow || "none",
    verticalAlign: numberInput.verticalAlign || "baseline",
    letterSpacing: numberInput.letterSpacing || "normal",
    wordSpacing: numberInput.wordSpacing || "normal",
    textIndent: numberInput.textIndent || "0",
    whiteSpace: numberInput.whiteSpace || "normal",
    textOverflow: numberInput.textOverflow || "clip",
    direction: numberInput.direction || "ltr",
    unicodeBidi: numberInput.unicodeBidi || "normal",
    writingMode: numberInput.writingMode || "horizontal-tb",

    opacity: numberInput.opacity || "1",
    display: numberInput.display || "inline",
    cursor: numberInput.cursor || "auto",

    transform: numberInput.transform || "none",
    transition: numberInput.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: numberInput.labelmargin || "0px",
    marginTop: numberInput.labelmarginTop || numberInput.labelmargin || "0",
    marginRight:
      numberInput.labelmarginRight || numberInput.labelmargin || "0px",
    marginBottom:
      numberInput.labelmarginBottom || numberInput.labelmargin || "0",
    marginLeft: numberInput.labelmarginLeft || numberInput.labelmargin || "0",
    padding: numberInput.labelpadding || "0px",
    paddingTop: numberInput.labelpaddingTop || numberInput.labelpadding || "0",
    paddingRight:
      numberInput.labelpaddingRight || numberInput.labelpadding || "0",
    paddingBottom:
      numberInput.labelpaddingBottom || numberInput.labelpadding || "0",
    paddingLeft:
      numberInput.labelpaddingLeft || numberInput.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : numberInput.labelborderTop || numberInput.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : numberInput.labelborderRight || numberInput.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : numberInput.labelborderBottom || numberInput.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : numberInput.labelborderLeft || numberInput.labelborder || "none",

    borderSapcing: numberInput.labelborderSpacing || "0px",
    borderCollapse: numberInput.labelborderCollapse || "0px",
    borderRadius: numberInput.labelborderRadius || "0",
    outline: numberInput.labeloutline || "none",

    position: numberInput.labelposition || "static",
    top: numberInput.labeltop || "auto",
    right: numberInput.labelright || "auto",
    bottom: numberInput.labelbottom || "auto",
    left: numberInput.labelleft || "auto",
    zIndex: numberInput.labelzIndex || "auto",

    color: numberInput.labelcolor || "#000000",
    backgroundColor: numberInput.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      numberInput.labelbackgroundPosition ||
      numberInput.labelbackgroundPosition ||
      "0% 0%",
    backgroundSize:
      numberInput.labelbackgroundSize ||
      numberInput.labelbackgroundSize ||
      "auto",
    backgroundRepeat:
      numberInput.labelbackgroundRepeat ||
      numberInput.labelbackgroundRepeat ||
      "repeat",
    backgroundAttachment:
      numberInput.labelbackgroundAttachment ||
      numberInput.labelbackgroundAttachment ||
      "scroll",

    fontSize: numberInput.labelfontSize || "inherit",
    fontFamily: numberInput.labelfontFamily || "inherit",
    fontWeight: numberInput.labelfontWeight || "normal",
    fontStyle: numberInput.labelfontStyle || "normal",
    fontVariant: numberInput.labelfontVariant || "normal",
    lineHeight: numberInput.labellineHeight || "normal",
    textAlign: numberInput.labeltextAlign || "left",
    textDecoration: numberInput.labeltextDecoration || "none",
    textTransform: numberInput.labeltextTransform || "none",
    textShadow: numberInput.labeltextShadow || "none",
    verticalAlign: numberInput.labelverticalAlign || "baseline",
    letterSpacing: numberInput.labelletterSpacing || "normal",
    wordSpacing: numberInput.labelwordSpacing || "normal",
    textIndent: numberInput.labeltextIndent || "0",
    whiteSpace: numberInput.labelwhiteSpace || "normal",
    textOverflow: numberInput.labeltextOverflow || "clip",
    direction: numberInput.labeldirection || "ltr",
    unicodeBidi: numberInput.labelunicodeBidi || "normal",
    writingMode: numberInput.labelwritingMode || "horizontal-tb",

    opacity: numberInput.labelopacity || "1",
    display: numberInput.display || "inline",
    cursor: numberInput.cursor || "auto",

    transform: numberInput.transform || "none",
    transition: numberInput.transition || "none",
  };

  return (
    <>
      <label style={labelStyle}>{numberInput.label || "Number Label"}</label>
      <input
        type="number"
        value={numberInput.value}
        placeholder={numberInput.placeholder || "Enter a number"}
        style={inputStyle}
        min={numberInput.min}
        max={numberInput.max}
        step={numberInput.step}
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
      />
    </>
  );
};

export default NumberInputComponent;
